package com.anjuros.website.redesign.sections.designs

import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

enum class DesignCategory(val label: RdText) {
    TRADES(RdText.DESIGNS_FILTER_TRADES),
    BEAUTY(RdText.DESIGNS_FILTER_BEAUTY),
    FOOD(RdText.DESIGNS_FILTER_FOOD),
    LOCAL(RdText.DESIGNS_FILTER_LOCAL),
}

class DesignEntry(
    val category: DesignCategory,
    val path: String,
    val image: RdImage.Asset,
    val title: RdText,
    val text: RdText,
    val alt: RdText,
    val alsoSuits: RdText,
    val linkText: RdText,
    val featured: Boolean = false,
)

/** Every design on the Designs page, in display order. */
val AllDesigns = listOf(
    DesignEntry(
        DesignCategory.TRADES, RdRoute.ELECTRICIAN, RdImage.DESIGN_ELECTRICIAN, RdText.CAT_ELECTRICIAN,
        RdText.CAT_ELECTRICIAN_TEXT, RdText.CAT_ELECTRICIAN_ALT, RdText.CAT_ELECTRICIAN_ALSO, RdText.CAT_ELECTRICIAN_LINK, featured = true
    ),
    DesignEntry(
        DesignCategory.TRADES, RdRoute.DECORATOR, RdImage.DESIGN_DECORATOR, RdText.CAT_DECORATOR,
        RdText.CAT_DECORATOR_TEXT, RdText.CAT_DECORATOR_ALT, RdText.CAT_DECORATOR_ALSO, RdText.CAT_DECORATOR_LINK, featured = true
    ),
    DesignEntry(
        DesignCategory.TRADES, RdRoute.HANDYMAN, RdImage.DESIGN_HANDYMAN, RdText.CAT_HANDYMAN,
        RdText.CAT_HANDYMAN_TEXT, RdText.CAT_HANDYMAN_ALT, RdText.CAT_HANDYMAN_ALSO, RdText.CAT_HANDYMAN_LINK, featured = true
    ),
    DesignEntry(
        DesignCategory.BEAUTY, RdRoute.HAIRDRESSER, RdImage.DESIGN_HAIRDRESSER, RdText.CAT_HAIRDRESSER,
        RdText.CAT_HAIRDRESSER_TEXT, RdText.CAT_HAIRDRESSER_ALT, RdText.CAT_HAIRDRESSER_ALSO, RdText.CAT_HAIRDRESSER_LINK
    ),
    DesignEntry(
        DesignCategory.LOCAL, RdRoute.DOG_WALKER, RdImage.DESIGN_DOG_WALKER, RdText.CAT_DOG_WALKER,
        RdText.CAT_DOG_WALKER_TEXT, RdText.CAT_DOG_WALKER_ALT, RdText.CAT_DOG_WALKER_ALSO, RdText.CAT_DOG_WALKER_LINK
    ),
    DesignEntry(
        DesignCategory.FOOD, RdRoute.BAKER, RdImage.DESIGN_BAKER, RdText.CAT_BAKER,
        RdText.CAT_BAKER_TEXT, RdText.CAT_BAKER_ALT, RdText.CAT_BAKER_ALSO, RdText.CAT_BAKER_LINK
    ),
    DesignEntry(
        DesignCategory.BEAUTY, RdRoute.INSTRUCTOR, RdImage.DESIGN_INSTRUCTOR, RdText.CAT_INSTRUCTOR,
        RdText.CAT_INSTRUCTOR_TEXT, RdText.CAT_INSTRUCTOR_ALT, RdText.CAT_INSTRUCTOR_ALSO, RdText.CAT_INSTRUCTOR_LINK
    ),
    DesignEntry(
        DesignCategory.FOOD, RdRoute.PUB, RdImage.DESIGN_PUB, RdText.CAT_PUB,
        RdText.CAT_PUB_TEXT, RdText.CAT_PUB_ALT, RdText.CAT_PUB_ALSO, RdText.CAT_PUB_LINK
    ),
)
